export var SkinEvent;
(function (SkinEvent) {
    SkinEvent["ON_MODEL_READY"] = "SkinEvent.ON_MODEL_READY";
    SkinEvent["ON_VIEW_READY"] = "SkinEvent.ON_VIEW_READY";
    SkinEvent["ON_READY"] = "SkinEvent.ON_READY";
    SkinEvent["ON_REQUEST_SKIN_READY_CALLBACK_EXECUTION"] = "SkinEvent.ON_REQUEST_SKIN_READY_CALLBACK_EXECUTION";
    SkinEvent["ON_PLAYER_READY"] = "SkinEvent.ON_PLAYER_READY";
    SkinEvent["ON_REQUEST_RESOURCE_LOAD"] = "SkinEvent.ON_REQUEST_RESOURCE_LOAD";
    SkinEvent["ON_RESIZE"] = "SkinEvent.ON_RESIZE";
    SkinEvent["ON_PLAYER_EVENT"] = "SkinEvent.ON_PLAYER_EVENT";
    SkinEvent["ON_PLAYER_CC_READY"] = "SkinEvent.ON_PLAYER_CC_READY";
    SkinEvent["ON_PLAYER_HOOK_EXECUTED"] = "SkinEvent.ON_PLAYER_HOOK_EXECUTED";
    SkinEvent["ON_GATE_OPEN_REQUEST"] = "SkinEvent.ON_GATE_OPEN_REQUEST";
    SkinEvent["ON_GATE_OPEN"] = "SkinEvent.ON_GATE_OPEN";
    SkinEvent["ON_GATE_READY"] = "SkinEvent.ON_GATE_READY";
    SkinEvent["ON_GATE_CLOSE_REQUEST"] = "SkinEvent.ON_GATE_CLOSE_REQUEST";
    SkinEvent["ON_GATE_REMOVED"] = "SkinEvent.ON_GATE_REMOVED";
    SkinEvent["ON_PRE_PLAYBACK_OPEN_REQUEST"] = "SkinEvent.ON_PRE_PLAYBACK_OPEN_REQUEST";
    SkinEvent["ON_PRE_PLAYBACK_OPEN"] = "SkinEvent.ON_PRE_PLAYBACK_OPEN";
    SkinEvent["ON_PRE_PLAYBACK_READY"] = "SkinEvent.ON_PRE_PLAYBACK_READY";
    SkinEvent["ON_PRE_PLAYBACK_CLOSE_REQUEST"] = "SkinEvent.ON_PRE_PLAYBACK_CLOSE_REQUEST";
    SkinEvent["ON_PRE_PLAYBACK_REMOVED"] = "SkinEvent.ON_PRE_PLAYBACK_REMOVED";
    SkinEvent["ON_CONTROLS_FORCE_SHOW_REQUEST"] = "SkinEvent.ON_CONTROLS_FORCE_SHOW_REQUEST";
    SkinEvent["ON_CONTROLS_FORCE_HIDE_REQUEST"] = "SkinEvent.ON_CONTROLS_FORCE_HIDE_REQUEST";
    SkinEvent["ON_CONTROLS_RESET"] = "SkinEvent.ON_CONTROLS_RESET";
    SkinEvent["ON_PANEL_OPEN_REQUEST"] = "SkinEvent.ON_PANEL_OPEN_REQUEST";
    SkinEvent["ON_PANEL_OPEN"] = "SkinEvent.ON_PANEL_OPEN";
    SkinEvent["ON_PANEL_READY"] = "SkinEvent.ON_PANEL_READY";
    SkinEvent["ON_PANEL_CLOSE_REQUEST"] = "SkinEvent.ON_PANEL_CLOSE_REQUEST";
    SkinEvent["ON_PANEL_VOD_TIMEOUT_YES"] = "SkinEvent.ON_PANEL_VOD_TIMEOUT_YES";
    SkinEvent["ON_PANEL_VOD_TIMEOUT_YES_DONT_ASK_AGAIN"] = "SkinEvent.ON_PANEL_VOD_TIMEOUT_YES_DONT_ASK_AGAIN";
    SkinEvent["ON_PANEL_VOD_TIMEOUT_NO_BUTTON_CLICK"] = "SkinEvent.ON_PANEL_VOD_TIMEOUT_NO_BUTTON_CLICK";
    SkinEvent["ON_PANEL_REMOVED"] = "SkinEvent.ON_PANEL_REMOVED";
    SkinEvent["ON_TWEEN_DOWN_THUMB_READY"] = "SkinEvent.ON_TWEEN_DOWN_THUMB_READY";
    SkinEvent["ON_TWEEN_DOWN_THUMB_BEFORE_CALLBACK"] = "SkinEvent.ON_TWEEN_DOWN_THUMB_BEFORE_CALLBACK";
    SkinEvent["ON_TWEEN_RESET"] = "SkinEvent.ON_TWEEN_RESET";
    SkinEvent["ON_TOOLTIP_SHOW_REQUEST"] = "SkinEvent.ON_TOOLTIP_SHOW_REQUEST";
    SkinEvent["ON_TOOLTIP_SHOW"] = "SkinEvent.ON_TOOLTIP_SHOW";
    SkinEvent["ON_TOOLTIP_HIDE_REQUEST"] = "SkinEvent.ON_TOOLTIP_HIDE_REQUEST";
    SkinEvent["ON_TOOLTIP_HIDE"] = "SkinEvent.ON_TOOLTIP_HIDE";
    SkinEvent["ON_TIMETIP_SHOW"] = "SkinEvent.ON_TIMETIP_SHOW";
    SkinEvent["ON_TIMETIP_HIDE"] = "SkinEvent.ON_TIMETIP_HIDE";
    SkinEvent["ON_WINDOW_RESIZE"] = "SkinEvent.ON_WINDOW_RESIZE";
    SkinEvent["ON_PLAYER_TWEEN_START"] = "SkinEvent.ON_PLAYER_TWEEN_START";
    SkinEvent["ON_PLAYER_TWEEN_FINISH"] = "SkinEvent.ON_PLAYER_TWEEN_FINISH";
    SkinEvent["ON_FULLSCREEN_REQUEST"] = "SkinEvent.ON_FULLSCREEN_REQUEST";
    SkinEvent["ON_FULLSCREEN_EXIT_REQUEST"] = "SkinEvent.ON_FULLSCREEN_EXIT_REQUEST";
    SkinEvent["ON_FULLSCREEN_CHANGE"] = "SkinEvent.ON_FULLSCREEN_CHANGE";
    SkinEvent["ON_FULLSCREEN_ERROR"] = "SkinEvent.ON_FULLSCREEN_ERROR";
    SkinEvent["ON_WINDOW_KEY_DOWN"] = "SkinEvent.ON_WINDOW_KEY_DOWN";
    SkinEvent["ON_WINDOW_KEY_PRESS"] = "SkinEvent.ON_WINDOW_KEY_PRESS";
    SkinEvent["ON_WINDOW_KEY_UP"] = "SkinEvent.ON_WINDOW_KEY_UP";
    SkinEvent["ON_MOUSE_ENTER_WINDOW"] = "SkinEvent.ON_MOUSE_ENTER_WINDOW";
    SkinEvent["ON_MOUSE_LEAVE_WINDOW"] = "SkinEvent.ON_MOUSE_LEAVE_WINDOW";
    SkinEvent["ON_MOUSE_MOVE_WINDOW"] = "SkinEvent.ON_MOUSE_MOVE_WINDOW";
    SkinEvent["ON_MOUSE_DOWN_WINDOW"] = "SkinEvent.ON_MOUSE_DOWN_WINDOW";
    SkinEvent["ON_MOUSE_UP_WINDOW"] = "SkinEvent.ON_MOUSE_UP_WINDOW";
    SkinEvent["ON_MOUSE_WHEEL_WINDOW"] = "SkinEvent.ON_MOUSE_WHEEL_WINDOW";
    SkinEvent["ON_MOUSE_ENTER_STAGE"] = "SkinEvent.ON_MOUSE_ENTER_STAGE";
    SkinEvent["ON_MOUSE_LEAVE_STAGE"] = "SkinEvent.ON_MOUSE_LEAVE_STAGE";
    SkinEvent["ON_MOUSE_MOVE_STAGE"] = "SkinEvent.ON_MOUSE_MOVE_STAGE";
    SkinEvent["ON_MOUSE_DOWN_STAGE"] = "SkinEvent.ON_MOUSE_DOWN_STAGE";
    SkinEvent["ON_MOUSE_UP_STAGE"] = "SkinEvent.ON_MOUSE_UP_STAGE";
    SkinEvent["ON_MOUSE_WHEEL_STAGE"] = "SkinEvent.ON_MOUSE_WHEEL_STAGE";
    SkinEvent["ON_TOUCH_START_WINDOW"] = "SkinEvent.ON_TOUCH_START_WINDOW";
    SkinEvent["ON_TOUCH_END_WINDOW"] = "SkinEvent.ON_TOUCH_END_WINDOW";
    SkinEvent["ON_TOUCH_CANCEL_WINDOW"] = "SkinEvent.ON_TOUCH_CANCEL_WINDOW";
    SkinEvent["ON_TOUCH_MOVE_WINDOW"] = "SkinEvent.ON_TOUCH_MOVE_WINDOW";
    SkinEvent["ON_TOUCH_START_STAGE"] = "SkinEvent.ON_TOUCH_START_STAGE";
    SkinEvent["ON_TOUCH_END_STAGE"] = "SkinEvent.ON_TOUCH_END_STAGE";
    SkinEvent["ON_TOUCH_CANCEL_STAGE"] = "SkinEvent.ON_TOUCH_CANCEL_STAGE";
    SkinEvent["ON_TOUCH_MOVE_STAGE"] = "SkinEvent.ON_TOUCH_MOVE_STAGE";
    SkinEvent["ON_TAB_VISIBILITY_CHANGE"] = "SkinEvent.ON_TAB_VISIBILITY_CHANGE";
    SkinEvent["ON_CONTROLS_SHOW"] = "SkinEvent.ON_CONTROLS_SHOW";
    SkinEvent["ON_CONTROLS_HIDE"] = "SkinEvent.ON_CONTROLS_HIDE";
    SkinEvent["ON_CONTROLS_LOCKED"] = "SkinEvent.ON_CONTROLS_LOCKED";
    SkinEvent["ON_STOP_REQUEST"] = "SkinEvent.ON_STOP_REQUEST";
    SkinEvent["ON_PAUSE_REQUEST"] = "SkinEvent.ON_PAUSE_REQUEST";
    SkinEvent["ON_PLAY_REQUEST"] = "SkinEvent.ON_PLAY_REQUEST";
    SkinEvent["ON_REWIND_REQUEST"] = "SkinEvent.ON_REWIND_REQUEST";
    SkinEvent["ON_FAST_FORWARD_REQUEST"] = "SkinEvent.ON_FAST_FORWARD_REQUEST";
    SkinEvent["ON_SEEK_BAR_PAUSE_INTERVAL_START_REQUEST"] = "SkinEvent.ON_SEEK_BAR_PAUSE_INTERVAL_START_REQUEST";
    SkinEvent["ON_SEEK_BAR_PAUSE_INTERVAL"] = "SkinEvent.ON_SEEK_BAR_PAUSE_INTERVAL";
    SkinEvent["ON_SEEK_BAR_PAUSE_INTERVAL_STOP_REQUEST"] = "SkinEvent.ON_SEEK_BAR_PAUSE_INTERVAL_STOP_REQUEST";
    SkinEvent["ON_SEEK_TO"] = "SkinEvent.ON_SEEK_TO";
    SkinEvent["ON_SEEK_TO_LIVE"] = "SkinEvent.ON_SEEK_TO_LIVE";
    SkinEvent["ON_SEEK_OVER_MOVE"] = "SkinEvent.ON_SEEK_OVER_MOVE";
    SkinEvent["ON_SEEK_OVER"] = "SkinEvent.ON_SEEK_OVER";
    SkinEvent["ON_SEEK_OUT"] = "SkinEvent.ON_SEEK_OUT";
    SkinEvent["ON_SKIP_BUTTON_SHOW"] = "SkinEvent.ON_SKIP_BUTTON_SHOW";
    SkinEvent["ON_SKIP_BUTTON_HIDE"] = "SkinEvent.ON_SKIP_BUTTON_HIDE";
    SkinEvent["ON_SKIP_BUTTON_VISIBLE"] = "SkinEvent.ON_SKIP_BUTTON_VISIBLE";
    SkinEvent["ON_SKIP_BUTTON_HIDDEN"] = "SkinEvent.ON_SKIP_BUTTON_HIDDEN";
    SkinEvent["ON_SHOW_AD_UI_REQUEST"] = "SkinEvent.ON_SHOW_AD_UI_REQUEST";
    SkinEvent["ON_AD_CLICK_OVERLAY_SHOW"] = "SkinEvent.ON_AD_CLICK_OVERLAY_SHOW";
    SkinEvent["ON_AD_CLICK_OVERLAY_HIDE"] = "SkinEvent.ON_AD_CLICK_OVERLAY_HIDE";
    SkinEvent["ON_VOLUME_UPDATE"] = "SkinEvent.ON_VOLUME_UPDATE";
    SkinEvent["ON_MUTE_ON"] = "SkinEvent.ON_MUTE_ON";
    SkinEvent["ON_MUTE_OFF"] = "SkinEvent.ON_MUTE_OFF";
    SkinEvent["ON_AUDIO_TRACK_UPDATE_REQUEST"] = "SkinEvent.ON_AUDIO_TRACK_UPDATE_REQUEST";
    SkinEvent["ON_CC_READY"] = "SkinEvent.ON_CC_READY";
    SkinEvent["ON_CC_SHOW_CLICK"] = "SkinEvent.ON_CC_SHOW_CLICK";
    SkinEvent["ON_CC_HIDE_CLICK"] = "SkinEvent.ON_CC_HIDE_CLICK";
    SkinEvent["ON_CC_SETTINGS_VO_UPDATE"] = "SkinEvent.ON_CC_SETTINGS_VO_UPDATE";
    SkinEvent["ON_CC_SETTINGS_RESET"] = "SkinEvent.ON_CC_SETTINGS_RESET";
    SkinEvent["ON_SETTINGS_VO_UPDATE"] = "SkinEvent.ON_SETTINGS_VO_UPDATE";
    SkinEvent["ON_AD_INFO_SHOW"] = "SkinEvent.ON_AD_INFO_SHOW";
    SkinEvent["ON_AD_INFO_HIDE"] = "SkinEvent.ON_AD_INFO_HIDE";
    SkinEvent["ON_CONTENT_END_RATING_SHOW_REQUEST"] = "SkinEvent.ON_CONTENT_END_RATING_SHOW_REQUEST";
    SkinEvent["ON_RATING_SHOW"] = "SkinEvent.ON_RATING_SHOW";
    SkinEvent["ON_RATING_HIDE"] = "SkinEvent.ON_RATING_HIDE";
    SkinEvent["ON_PRODUCT_PLACEMENT_SHOW"] = "SkinEvent.ON_PRODUCT_PLACEMENT_SHOW";
    SkinEvent["ON_PRODUCT_PLACEMENT_HIDE"] = "SkinEvent.ON_PRODUCT_PLACEMENT_HIDE";
    SkinEvent["ON_METADATA_SHOW"] = "SkinEvent.ON_METADATA_SHOW";
    SkinEvent["ON_METADATA_HIDE"] = "SkinEvent.ON_METADATA_HIDE";
    SkinEvent["ON_REPLAY_REQUEST"] = "SkinEvent.ON_REPLAY_REQUEST";
    SkinEvent["ON_PRE_PLAY_RESTART_REQUEST"] = "SkinEvent.ON_RESTART_REQUEST";
    SkinEvent["ON_LTS_OPT_IN_SUCCESS"] = "SkinEvent.ON_LTS_OPT_IN_SUCCESS";
    SkinEvent["ON_LTS_OPT_IN_FAILURE"] = "SkinEvent.ON_LTS_OPT_IN_FAILURE";
    SkinEvent["ON_SFB_PANEL_WATCH_LIVE"] = "SkinEvent.ON_SFB_PANEL_WATCH_LIVE";
    SkinEvent["ON_SFB_PANEL_START_FROM_BEGINNING"] = "SkinEvent.ON_SFB_PANEL_START_FROM_BEGINNING";
    SkinEvent["ON_SFB_PANEL_HIGHLIGHTS"] = "SkinEvent.ON_SFB_PANEL_HIGHLIGHTS";
    SkinEvent["ON_API_LOAD_VIDEO_REQUEST"] = "SkinEvent.ON_API_LOAD_VIDEO_REQUEST";
    SkinEvent["ON_API_SKIN_RESET_REQUEST"] = "SkinEvent.ON_API_SKIN_RESET_REQUEST";
    SkinEvent["ON_BEFORE_TAG_PLAYER_STOP_REQUEST"] = "SkinEvent.ON_BEFORE_TAG_PLAYER_STOP_REQUEST";
    SkinEvent["ON_API_LOAD_STOP_PLAYER_REQUEST"] = "SkinEvent.ON_API_LOAD_STOP_PLAYER_REQUEST";
    SkinEvent["ON_API_LOAD_STOP_PLAYER_SUCCESS"] = "SkinEvent.ON_API_LOAD_STOP_PLAYER_SUCCESS";
    SkinEvent["ON_PAUSE_AD_REQUEST"] = "SkinEvent.ON_PAUSE_AD_REQUEST";
    SkinEvent["ON_PAUSE_AD_DATA_START"] = "SkinEvent.ON_PAUSE_AD_DATA_START";
    SkinEvent["ON_PAUSE_AD_DATA_LOAD_SUCCESS"] = "SkinEvent.ON_PAUSE_AD_DATA_LOAD_SUCCESS";
    SkinEvent["ON_PAUSE_AD_DATA_LOAD_FAILURE"] = "SkinEvent.ON_PAUSE_AD_DATA_LOAD_FAILURE";
    SkinEvent["ON_CP_END_CARD_VIEW"] = "SkinEvent.ON_CP_END_CARD_VIEW";
    SkinEvent["ON_CP_END_CARD_SELECT"] = "SkinEvent.ON_CP_END_CARD_SELECT";
    SkinEvent["ON_CP_NEXT_VIDEO_SELECT"] = "SkinEvent.ON_CP_NEXT_VIDEO_SELECT";
    SkinEvent["ON_CP_END_CARD_SELECT_CREDITS"] = "SkinEvent.ON_CP_END_CARD_SELECT_CREDITS";
    SkinEvent["ON_CP_END_CARD_CANCEL"] = "SkinEvent.ON_CP_END_CARD_CANCEL";
    SkinEvent["ON_CP_SAVE_SESSION_DATA_COMPLETE"] = "SkinEvent.ON_CP_SAVE_SESSION_DATA_COMPLETE";
    SkinEvent["ON_CP_ERASE_SESSION_DATA_COMPLETE"] = "SkinEvent.ON_CP_ERASE_SESSION_DATA_COMPLETE";
    SkinEvent["ON_CP_COUNTDOWN_UPDATE"] = "SkinEvent.ON_CP_COUNTDOWN_UPDATE";
    SkinEvent["ON_FCH_END_CONTENT_VIEW"] = "SkinEvent.ON_FCH_END_CONTENT_VIEW";
    SkinEvent["ON_FCH_END_CONTENT_SELECT_CTA"] = "SkinEvent.ON_FCH_END_CONTENT_SELECT_CTA";
    SkinEvent["ON_FCH_END_CONTENT_SELECT_CREDITS"] = "SkinEvent.ON_FCH_END_CONTENT_SELECT_CREDITS";
    SkinEvent["ON_FCH_END_CONTENT_END"] = "SkinEvent.ON_FCH_END_CONTENT_END";
    SkinEvent["ON_DISABLE_END_PANEL"] = "SkinEvent.ON_DISABLE_END_PANEL";
    SkinEvent["ON_ENABLE_END_PANEL"] = "SkinEvent.ON_ENABLE_END_PANEL";
    SkinEvent["ON_BTN_CAST_CLICK"] = "SkinEvent.ON_BTN_CAST_CLICK";
    SkinEvent["ON_NEXT_VIDEO_CLICK"] = "SkinEvent.ON_NEXT_VIDEO_CLICK";
    SkinEvent["ON_CAST_UI_READY"] = "SkinEvent.ON_CAST_UI_READY";
    SkinEvent["ON_CAST_SESSION_REQUEST_SUCCESS"] = "SkinEvent.ON_CAST_SESSION_REQUEST_SUCCESS";
    SkinEvent["ON_CAST_SESSION_REQUEST_ERROR"] = "SkinEvent.ON_CAST_SESSION_REQUEST_ERROR";
    SkinEvent["ON_CAST_ENABLE"] = "SkinEvent.ON_CAST_ENABLE";
    SkinEvent["ON_CAST_DISABLE"] = "SkinEvent.ON_CAST_DISABLE";
    SkinEvent["ON_CAST_START"] = "SkinEvent.ON_CAST_START";
    SkinEvent["ON_CAST_END"] = "SkinEvent.ON_CAST_END";
    SkinEvent["ON_CAST_INITIALIZE"] = "SkinEvent.ON_CAST_INITIALIZE";
    SkinEvent["ON_CAST_SETUP_AD_BREAKS"] = "SkinEvent.ON_CAST_SETUP_AD_BREAKS";
    SkinEvent["ON_CAST_SET_METADATA"] = "SkinEvent.ON_CAST_SET_METADATA";
    SkinEvent["ON_CAST_PLAYLIST_START"] = "SkinEvent.ON_CAST_PLAYLIST_START";
    SkinEvent["ON_CAST_PLAYLIST_END"] = "SkinEvent.ON_CAST_PLAYLIST_END";
    SkinEvent["ON_CAST_CONTENT_START"] = "SkinEvent.ON_CAST_CONTENT_START";
    SkinEvent["ON_CAST_CONTENT_END"] = "SkinEvent.ON_CAST_CONTENT_END";
    SkinEvent["ON_CAST_AD_BREAK_START"] = "SkinEvent.ON_CAST_AD_BREAK_START";
    SkinEvent["ON_CAST_AD_BREAK_END"] = "SkinEvent.ON_CAST_AD_BREAK_END";
    SkinEvent["ON_CAST_SESSION_ERROR"] = "SkinEvent.ON_CAST_SESSION_ERROR";
    SkinEvent["ON_CAST_SESSION_END"] = "SkinEvent.ON_CAST_SESSION_END";
    SkinEvent["ON_CAST_PLAYER_STATE"] = "SkinEvent.ON_CAST_PLAYER_STATE";
    SkinEvent["ON_CAST_PLAYBACK_PROGRESS"] = "SkinEvent.ON_CAST_PLAYBACK_PROGRESS";
    SkinEvent["ON_CAST_VOLUME_UPDATE"] = "SkinEvent.ON_CAST_VOLUME_UPDATE";
    SkinEvent["ON_CAST_MUTE"] = "SkinEvent.ON_CAST_MUTE";
    SkinEvent["ON_CAST_UNMUTE"] = "SkinEvent.ON_CAST_UNMUTE";
    SkinEvent["ON_CAST_SET_CC"] = "SkinEvent.ON_CAST_SET_CC";
    SkinEvent["ON_CAST_SET_MEDIA_TRACKS"] = "SkinEvent.ON_CAST_SET_MEDIA_TRACKS";
    SkinEvent["ON_CAST_SET_AUDIO_TRACK"] = "SkinEvent.ON_CAST_SET_AUDIO_TRACK";
    SkinEvent["ON_CAST_SET_CC_INFO"] = "SkinEvent.ON_CAST_SET_CC_INFO";
    SkinEvent["ON_CAST_SET_STREAM_TYPE"] = "SkinEvent.ON_CAST_SET_STREAM_TYPE";
    SkinEvent["ON_CAST_SEND_LOAD_REQUEST"] = "SkinEvent.ON_CAST_SEND_LOAD_REQUEST";
    SkinEvent["ON_CAST_PRE_CAST_HANDLER"] = "SkinEvent.ON_CAST_PRE_CAST_HANDLER";
    SkinEvent["ON_CAST_SHOW_NEXT_VIDEO_BTN"] = "SkinEvent.ON_CAST_SHOW_NEXT_VIDEO_BTN";
    SkinEvent["ON_CAST_HIDE_NEXT_VIDEO_BTN"] = "SkinEvent.ON_CAST_HIDE_NEXT_VIDEO_BTN";
    SkinEvent["ON_ONLINE"] = "SkinEvent.ON_ONLINE";
    SkinEvent["ON_OFFLINE"] = "SkinEvent.ON_OFFLINE";
    SkinEvent["ON_FATAL_ERROR"] = "SkinEvent.ON_FATAL_ERROR";
    SkinEvent["ON_PAGE_ACTION"] = "SkinEvent.ON_PAGE_ACTION";
    SkinEvent["ON_HOTKEY_KEYDOWN"] = "SkinEvent.ON_HOTKEY_KEYDOWN";
    SkinEvent["ON_SIDE_BAR_PLUGIN_LOCALS_KEYDOWN"] = "SkinEvent.ON_SIDE_BAR_PLUGIN_LOCALS_KEYDOWN";
    SkinEvent["ON_TRACK_SUCCESS"] = "SkinEvent.ON_TRACK_SUCCESS";
    SkinEvent["BROWSER_POP_STATE"] = "SkinEvent.BROWSER_POP_STATE";
    SkinEvent["SET_ENDCARD_DATA"] = "SkinEvent.SET_CARD_DATA";
    SkinEvent["ON_CP_ENDCARD_DATA_RECEIVED"] = "SkinEvent.ON_CP_ENDCARD_DATA_RECEIVED";
    SkinEvent["ON_RECOMMENDATIONS_ENDCARD_DATA_RECEIVED"] = "SkinEvent.ON_RECOMMENDATIONS_ENDCARD_DATA_RECEIVED";
    SkinEvent["ON_INVALID_ENDCARD_DATA_RECEIVED"] = "SkinEvent.ON_INVALID_ENDCARD_DATA_RECEIVED";
    SkinEvent["GET_MIDCARD_RECOMMENDATION"] = "SkinEvent.GET_MIDCARD_RECOMMENDATION";
    SkinEvent["GOT_MIDCARD_RECOMMENDATION"] = "SkinEvent.GOT_MIDCARD_RECOMMENDATION";
    SkinEvent["GET_MIDCARD_REDIRECT"] = "SkinEvent.GET_MIDCARD_REDIRECT";
    SkinEvent["GOT_MIDCARD_REDIRECT"] = "SkinEvent.GOT_MIDCARD_REDIRECT";
    SkinEvent["MIDCARD_ERROR"] = "SkinEvent.MIDCARD_ERROR";
    SkinEvent["ENDCARD_VIEW"] = "SkinEvent.ENDCARD_VIEW";
    SkinEvent["ENDCARD_SELECT"] = "SkinEvent.ENDCARD_SELECT";
    SkinEvent["MIDCARD_SELECT"] = "SkinEvent.MIDCARD_SELECT";
    SkinEvent["ON_UEC_SELECT_CREDITS"] = "SkinEvent.ON_UEC_SELECT_CREDITS";
    SkinEvent["ON_UEC_TOGGLE_DESCRIPTION_BTN_SELECTED"] = "SkinEvent.ON_UEC_TOGGLE_DESCRIPTION_BTN_SELECTED";
    SkinEvent["ON_UEC_DESCRIPTION_UPDATED"] = "SkinEvent.ON_UEC_DESCRIPTION_UPDATED";
    SkinEvent["ON_UEC_TIMER_STOP"] = "SkinEvent.ON_UEC_TIMER_STOP";
    SkinEvent["ON_UEC_TIMER_RESET"] = "SkinEvent.ON_UEC_TIMER_RESET";
    SkinEvent["RECOMMENDATION_HOVER"] = "SkinEvent.RECOMMENDATION_HOVER";
    SkinEvent["RECOMMENDATION_SELECT"] = "SkinEvent.RECOMMENDATION_SELECT";
    SkinEvent["ON_DISABLE_MOUSE_CONTROLS"] = "SkinEvent.ON_DISABLE_MOUSE_CONTROLS";
    SkinEvent["ON_ENABLE_MOUSE_CONTROLS"] = "SkinEvent.ON_ENABLE_MOUSE_CONTROLS";
    SkinEvent["ON_DISABLE_KEYBOARD_CONTROLS"] = "SkinEvent.ON_DISABLE_KEYBOARD_CONTROLS";
    SkinEvent["ON_ENABLE_KEYBOARD_CONTROLS"] = "SkinEvent.ON_ENABLE_KEYBOARD_CONTROLS";
    SkinEvent["ON_HIGHLIGHTS_DATA_REQUEST"] = "SkinEvent.ON_HIGHLIGHTS_DATA_REQUEST";
    SkinEvent["ON_HIGHLIGHTS_DATA_UPDATE"] = "SkinEvent.ON_HIGHLIGHTS_DATA_UPDATE";
    SkinEvent["ON_NEW_RELATED_VIDEOS_RECEIVED"] = "SkinEvent.ON_NEW_RELATED_VIDEOS_RECEIVED";
    SkinEvent["ON_START_CARD_HIGHLIGHTS_EXIT"] = "SkinEvent.ON_START_CARD_HIGHLIGHTS_EXIT";
    SkinEvent["ON_CONTROLS_HIGHLIGHTS_SELECT"] = "SkinEvent.ON_CONTROLS_HIGHLIGHTS_SELECT";
    SkinEvent["ON_LISTING_CHANGE_REQUEST"] = "SkinEvent.ON_LISTING_CHANGE_REQUEST";
    SkinEvent["ON_FEATURE_TOOLTIP_SHOW"] = "SkinEvent.ON_FEATURE_TOOLTIP_SHOW";
    SkinEvent["ON_FEATURE_TOOLTIP_HIDE"] = "SkinEvent.ON_FEATURE_TOOLTIP_HIDE";
})(SkinEvent || (SkinEvent = {}));
export const skinEvents = () => {
    const out = [];
    Object.keys(SkinEvent).forEach((key) => {
        out.push(SkinEvent[key]);
    });
    return out;
};
